import Vue from "vue";

export function createNotesController() {
  const state = Vue.observable({
    visible: false,
    isEditing: false,
    style: {},
    row: null,
    placement: "bottom",
  });

  let activeTableBody = null;
  let scrollHandler = null;
  let saveCallback = null;
  let hoverTimeout = null;

  const setSaveCallback = (cb) => {
    saveCallback = cb;
  };

  const show = async ({ target, row, mode = "edit", noteHeight = 163 }) => {
    clearTimeout(hoverTimeout);

    if (
      state.visible &&
      state.isEditing &&
      state.row &&
      state.row.id !== row.id
    ) {
      if (saveCallback) {
        await saveCallback();
      }
    }

    if (
      state.visible &&
      state.isEditing &&
      state.row &&
      state.row.id === row.id &&
      mode === "view"
    ) {
      return;
    }

    state.row = row;
    state.isEditing = mode === "edit";

    const tableBody = target.closest(".table-body");
    if (!tableBody) return;

    if (activeTableBody && scrollHandler && activeTableBody !== tableBody) {
      activeTableBody.removeEventListener("scroll", scrollHandler);
    }

    const targetRect = target.getBoundingClientRect();
    const bodyRect = tableBody.getBoundingClientRect();

    const spaceBelow = bodyRect.bottom - targetRect.bottom;
    const spaceAbove = targetRect.top - bodyRect.top;
    const threshold = noteHeight + 20;

    let placement = "bottom";
    if (spaceBelow < threshold && spaceAbove > spaceBelow) {
      placement = "top";
    }

    let top;
    if (placement === "bottom") {
      top = targetRect.bottom - bodyRect.top + tableBody.scrollTop + 8;
    } else {
      top =
        targetRect.top - bodyRect.top + tableBody.scrollTop - noteHeight - 8;
    }

    const left = targetRect.left - bodyRect.left + tableBody.scrollLeft + 4;

    state.style = {
      position: "absolute",
      top: `${top}px`,
      left: `${left}px`,
      zIndex: 1000,
    };
    state.placement = placement;

    state.visible = true;
    activeTableBody = tableBody;

    if (!scrollHandler) {
      scrollHandler = async () => {
        if (saveCallback) {
          await saveCallback();
        }
        hide();
      };
      activeTableBody.addEventListener("scroll", scrollHandler, { once: true });
    }
  };

  const hide = () => {
    state.visible = false;
    state.isEditing = false;
    if (activeTableBody && scrollHandler) {
      activeTableBody.removeEventListener("scroll", scrollHandler);
      activeTableBody = null;
      scrollHandler = null;
    }
  };

  const hideHover = () => {
    if (state.visible && !state.isEditing) {
      hoverTimeout = setTimeout(() => {
        hide();
      }, 350);
    }
  };

  const cancelHide = () => {
    clearTimeout(hoverTimeout);
  };

  const enableEdit = () => {
    state.isEditing = true;
  };

  return {
    state,
    show,
    hide,
    hideHover,
    cancelHide,
    enableEdit,
    setSaveCallback,
  };
}
